'use strict';

var angular = require('angular');
var dependencies = ['ui.router'];
module.exports = angular.module('AVRO.Userlanding.Panel', dependencies).config(require('./config/UserLandingPanelConfig'));